// New/Edit/View order
// Draft orders
// Sales
// Orders
// Removal orders

import SingleOrder from '~cp/UserPanel/Pages/Orders/SingleOrder/SingleOrder'
import DraftOrders from '~cp/UserPanel/Pages/Orders/DraftOrders'
import Orders from '~cp/UserPanel/Pages/Orders/Orders'
import Sales from '~cp/UserPanel/Pages/Orders/Sales'
import RemovalOrders from '~cp/UserPanel/Pages/Orders/RemovalOrders'

export default [
    {
        path: 'orders',
        name: 'Orders',
        component: Orders,
        meta: {
            breadcrumb: {
                text: 'Orders'
            }
        }
    },
    {
        path: 'sales',
        name: 'Sales',
        component: Sales,
        meta: {
            breadcrumb: {
                text: 'Sales'
            }
        }
    },
    {
        path: 'draft-orders',
        name: 'DraftOrders',
        component: DraftOrders,
        meta: {
            breadcrumb: {
                text: 'Draft orders'
            }
        }
    },
    {
        path: 'new-order',
        name: 'NewOrder',
        component: SingleOrder,
        meta: {
            breadcrumb: {
                text: 'New order'
            }
        }
    },
    {
        path: ':orderId',
        name: 'SingleOrder',
        component: SingleOrder,
        props: true,
        meta: {
            breadcrumb: {
                getText: route => `View order ${route.params.orderId}`,
                parent: true
            }
        }
    },
    {
        path: ':orderId/fulfillment',
        name: 'OrderFulfillment',
        component: () => import('~cp/UserPanel/Pages/Orders/OrderFulfillment/OrderFulfillment'),
        props: true,
        meta: {
            breadcrumb: {
                text: 'Order fulfillment',
                parent: true
            }
        }
    },
    {
        path: 'removal-orders',
        name: 'RemovalOrders',
        component: RemovalOrders,
        meta: {
            breadcrumb: {
                text: 'Removal orders'
            }
        }
    },
]



// WEBPACK FOOTER //
// ./src/router/modules/orders-routes.js